import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Form, Field } from 'react-final-form'

import userActions from '../../context/users/actions';
import { ToastContainer, notify } from '../../libraries/notifications';
import { composeValidators, validateEmail, validateIsfilled } from '../../libraries/utils';

import { history } from '../../routes';
import config from '../../config';

import LayoutSmall from '../../components/layout/LayoutSmall';
import Button from '../../components/commons/Button';
import TextInput from '../../components/forms/TextInput';

import Swal from 'sweetalert2';

class Forgot extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      password: false,
    }
  }
  
  componentDidMount() {
    console.log('FORGOT PASSWORD PAGE');
  }
  
  onSubmit = async values => {
    const data = { ...values };
    await this.props.onForgot(data);
    console.log('AFTER FORGOT');
    const error = this.props.auth.error;
    if (error) { 
      notify(this.t(error.message));
    } else {
      //notify("Email enviado");
      const swalWithStyle = Swal.mixin({
        customClass: {
          confirmButton: 'btn btn-primary mr-2',
        },
        buttonsStyling: false
      })
      swalWithStyle.fire({
        title: this.t("Recuperación de contraseña"),
        text: this.t("Email enviado, revise su casilla de email"),
        icon: 'success',
        confirmButtonText: this.t("Aceptar"),
      })
      .then((result) => {
        if (result.isConfirmed) {
          history.push(config.ROUTES.LOGIN);
        }
      });    
    }
  }


  render() {

    const required = value => (validateIsfilled(value) ? undefined : this.t("This field is required"))
    const email = value => (validateEmail(value) ? undefined : this.t("Not a valid email"))

    return (
      <LayoutSmall
        main={{ className: "bg-base-200 text-primary bg-pattern"}}
        header={{ 
          title: this.t("Reset password"),
          className: "!bg-transparent !text-primary",
          left: { icon: 'arrow_left', action: () => history.push(config.ROUTES.USER.PROFILE) }
        }}
        container={{
          className: "mt-10"
        }}
      >
        <ToastContainer/>

        <Form onSubmit={this.onSubmit}>
          {({ handleSubmit, form, submitting, pristine, values }) => (
            <form onSubmit={handleSubmit} className="w-full max-w-lg mx-auto px-4">
              <div className="w-full mb-3 md:mb-0">
                <Field name="email" component={TextInput} placeholder={this.t("Email")} label={this.t("Ingresé su correo")} validate={composeValidators(required, email)}/>
              </div>
              <Button
                className="btn-primary btn-block mt-5"
                title={this.t("Send")}
                onClick={handleSubmit}
              />
            </form>
          )}
        </Form>
      </LayoutSmall>
    ) 
  }
}

const mapStateToProps = state => {
  return {
    auth: state.users.auth
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onForgot: (values) => dispatch(userActions.forgot(values)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Forgot));

